module.exports = __webpack_public_path__ + "fonts/EuclidSquare-Bold.woff2";